import GridViewIcon from '@mui/icons-material/GridView'
import EventBusyIcon from '@mui/icons-material/EventBusy'
import PlumbingIcon from '@mui/icons-material/Plumbing'
import BrushIcon from '@mui/icons-material/Brush'
import DesignServicesIcon from '@mui/icons-material/DesignServices'
import BarChartIcon from '@mui/icons-material/BarChart'
import SendIcon from '@mui/icons-material/Send'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import TableChartIcon from '@mui/icons-material/TableChart'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import SettingsIcon from '@mui/icons-material/Settings'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import PreviewIcon from '@mui/icons-material/Preview'
import CampaignIcon from '@mui/icons-material/Campaign'
import InsightsIcon from '@mui/icons-material/Insights'
import AbcIcon from '@mui/icons-material/Abc'
import BlockIcon from '@mui/icons-material/Block'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import CallSplitIcon from '@mui/icons-material/CallSplit'
import FindInPageIcon from '@mui/icons-material/FindInPage'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'

export const AlertPosition = {
    vertical: 'bottom',
    horizontal: 'right',
}

export const AlertType = {
    success: 'success',
    error: 'error',
    info: 'info',
    warning: 'warning',
}

export const environments = {
    dev: {
        baseURL: 'https://api.dev.bhanzu.com',
        redirectURL: 'https://comms.dev.bhanzu.com',
        domain: 'comms.dev.bhanzu.com',
    },
    stage: {
        baseURL: 'https://api.stage.bhanzu.com',
        redirectURL: 'https://comms.stage.bhanzu.com',
        domain: 'comms.stage.bhanzu.com',
    },
    prod: {
        baseURL: 'https://api.bhanzu.com',
        redirectURL: 'https://comms.bhanzu.com',
        domain: 'comms.bhanzu.com',
    },
}

export const AUTH_COOKIE = 'bhanzu-admin-auth'
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong!'

export const commTypes = [
    {
        id: 1,
        label: 'Email',
        value: 'email',
    },
    {
        id: 2,
        label: 'WhatsApp',
        value: 'whatsapp',
    },
    {
        id: 3,
        label: 'SMS',
        value: 'sms',
    },
    {
        id: 4,
        label: 'Voice',
        value: 'voice',
    },
    {
        id: 5,
        label: 'Push Notification',
        value: 'push_notification',
    },
    {
        id: 6,
        label: 'Slack',
        value: 'slack',
    },
]
export const receiverTypes = [
    {
        id: 1,
        label: 'Demo Student',
        value: 'demo_student',
    },
    {
        id: 2,
        label: 'Batch Student',
        value: 'batch_student',
    },
    {
        id: 3,
        label: 'Teacher',
        value: 'teacher',
    },
    {
        id: 4,
        label: 'Parents',
        value: 'parents',
    },
    {
        id: 5,
        label: 'Inline',
        value: '__inline',
    },
    // The service accepts these two as well (models/enums.py CommReceiver);
    // one production pipeline sends to a sales manager. This list is the
    // fallback for when GET /comms/v2/pipeline/create/enums cannot be read.
    {
        id: 6,
        label: 'Demo Teacher',
        value: 'demo_teacher',
    },
    {
        id: 7,
        label: 'Sales Manager',
        value: 'sales_manager',
    },
]

// The WhatsApp accounts a template sends from (its `channel`), named as the
// old comms app named them. A template with no channel sends from `default`.
export const WHATSAPP_ACCOUNTS = [
    { value: 'default', label: 'Engineering' },
    { value: 'dce-12', label: 'Marketing' },
    { value: 'people-ops', label: 'People Ops' },
]

// The email sender's own default From address (lambda-comms-internal-trigger
// email_template.py), used when a template has no `source_email`.
export const DEFAULT_SENDER_EMAIL = 'no-reply@bhanzu.com'

export const eventTypes = [
    {
        id: 1,
        label: 'Student removed from batch',
        value: 'batch_completed',
    },
    {
        id: 2,
        label: 'Post login register reminder student',
        value: 'post_login_register_reminder_student',
    },
    {
        id: 3,
        label: 'Post login register reminder parent',
        value: 'post_login_register_reminder_parent',
    },
    {
        id: 4,
        label: 'Send comms to parents',
        value: 'send_comms_to_parents',
    },
    {
        id: 5,
        label: 'Dashboard feature update student',
        value: 'dashboard_feature_update_student',
    },
    {
        id: 6,
        label: 'Dashboard feature update parent',
        value: 'dashboard_feature_update_parent',
    },
]

export const roles = {
    DEV_ADMIN: 'dev-admins',
    PROD_ADMIN: 'prod-admins',
    DEV_DESIGNER: 'dev-designer',
    PROD_DESIGNER: 'prod-designer',
    DEV_OPERATIONS: 'dev-ops',
    PROD_OPERATIONS: 'prod-ops',
    // The applause app's comms role: the one group its users were given to
    // change what gets sent (helpers/permissions commsManagerRole).
    DEV_COMMS_TOOL: 'comms-tool-dev',
    PROD_COMMS_TOOL: 'comms-tool-prod',
}

// The old comms app (comms.bhanzu.com/old) admitted anyone signed in and kept
// changes for the comms-tool role, so a comms-tool holder outside the six
// groups below must still be able to open every Operate and Studio page.
const COMMS_TOOL = [roles.DEV_COMMS_TOOL, roles.PROD_COMMS_TOOL]

// Who may use each part of the app. The sidebar (menuItems) and the route
// table (routes/routes.js) both read these, so a page can never be shown in
// the menu yet refused by its route, or the other way round
// (routes/routes.test.js checks every menu link against its route).
// Client-side only: the API authorises every call itself.
// Every comms role group: whoever has access to comms at all.
const EVERY_COMMS_ROLE = [
    roles.DEV_ADMIN,
    roles.PROD_ADMIN,
    roles.DEV_DESIGNER,
    roles.PROD_DESIGNER,
    roles.DEV_OPERATIONS,
    roles.PROD_OPERATIONS,
    ...COMMS_TOOL,
]

export const ROLE_SETS = {
    everyone: EVERY_COMMS_ROLE,
    operate: [
        roles.DEV_ADMIN,
        roles.PROD_ADMIN,
        roles.DEV_OPERATIONS,
        roles.PROD_OPERATIONS,
        ...COMMS_TOOL,
    ],
    studio: [
        roles.DEV_ADMIN,
        roles.PROD_ADMIN,
        roles.DEV_DESIGNER,
        roles.PROD_DESIGNER,
        ...COMMS_TOOL,
    ],
    // The ten AI tools: everyone with comms access (2026-10-20; dev-admins only
    // before). None of them sends anything, and their model and keys stay in
    // Settings, which is still dev-admins only.
    aiSuite: EVERY_COMMS_ROLE,
    devAdmin: [roles.DEV_ADMIN],
    // Trainer dashboard notifications (pages/TrainerNotifications): admins and
    // the comms tool groups. The services check the same list.
    trainerNotifications: [roles.DEV_ADMIN, roles.PROD_ADMIN, ...COMMS_TOOL],
    // Every signed-in user, with or without a comms group: the Guide.
    // Empty roles are never checked (RequireRoles is skipped for them).
    signedIn: [],
}

export const features = {
    CONTAINER_CONTROL_PANEL: 'container-control-panel',
    CREATE_TEMPLATE_BUTTON: 'create-template-button',
    SELECTED_TEMPLATE_TEXT: 'selected-template-text',
}

export const permissions = {
    [roles.PROD_ADMIN]: [
        features.CONTAINER_CONTROL_PANEL,
        features.SELECTED_TEMPLATE_TEXT,
    ],
    [roles.DEV_ADMIN]: [
        features.CONTAINER_CONTROL_PANEL,
        features.SELECTED_TEMPLATE_TEXT,
    ],
    [roles.DEV_DESIGNER]: [features.CREATE_TEMPLATE_BUTTON],
}

export const menuItems = [
    {
        title: 'Home',
        icon: <GridViewIcon />,
        permissions: ROLE_SETS.everyone,
        link: '/',
    },
    {
        type: 'section',
        label: 'Operate',
        permissions: ROLE_SETS.operate,
    },
    {
        title: 'Pipelines',
        icon: <PlumbingIcon />,
        permissions: ROLE_SETS.operate,
        link: '/pipelines',
    },
    {
        title: 'Bulk Send',
        icon: <SendIcon />,
        permissions: ROLE_SETS.operate,
        link: '/bulk-send',
    },
    {
        title: 'Reports',
        icon: <BarChartIcon />,
        permissions: ROLE_SETS.operate,
        link: '/reports',
    },
    {
        title: 'Holidays',
        icon: <EventBusyIcon />,
        permissions: ROLE_SETS.operate,
        link: '/holidays',
    },
    {
        type: 'section',
        label: 'Studio',
        permissions: ROLE_SETS.studio,
    },
    {
        title: 'Templates',
        icon: <DesignServicesIcon />,
        permissions: ROLE_SETS.studio,
        link: '/templates',
        badge: 'approvals',
    },
    {
        title: 'Create Template',
        icon: <BrushIcon />,
        permissions: ROLE_SETS.studio,
        link: '/create-template',
        // Creating a template changes what can be sent: shown only to the
        // comms manager role (hooks/useCommsManager), as the route requires.
        // One entry: the form itself offers "From an HTML file" for an email
        // (the old /upload-template address still opens it on that choice).
        manager: true,
    },
    {
        title: 'Trainer Notifications',
        icon: <NotificationsActiveIcon />,
        permissions: ROLE_SETS.trainerNotifications,
        link: '/trainer-notifications',
    },
    {
        type: 'section',
        label: 'AI Suite',
        link: '/',
        permissions: ROLE_SETS.aiSuite,
    },
    {
        title: 'Template Writer',
        icon: <AutoAwesomeIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/template-writer',
    },
    {
        title: 'CSV Validator',
        icon: <TableChartIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/csv-validator',
    },
    {
        title: 'Bulk Preview',
        icon: <PreviewIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/bulk-preview',
    },
    {
        title: 'Campaign Brief',
        icon: <CampaignIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/campaign-brief',
    },
    {
        title: 'Perf. Insights',
        icon: <InsightsIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/performance-insights',
    },
    {
        title: 'A/B Variants',
        icon: <AbcIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/ab-variants',
    },
    {
        title: 'Unsub. Risk',
        icon: <BlockIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/unsubscribe-risk',
    },
    {
        title: 'Audience Overlap',
        icon: <PeopleAltIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/audience-overlap',
    },
    {
        title: 'CRM Enrich',
        icon: <ManageSearchIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/crm-enrich',
    },
    {
        title: 'Comms Finder',
        icon: <FindInPageIcon />,
        permissions: ROLE_SETS.aiSuite,
        link: '/ai/comms-finder',
    },
    {
        title: 'Reputation',
        icon: <ShieldOutlinedIcon />,
        permissions: ROLE_SETS.devAdmin,
        link: '/reputation',
    },
    {
        title: 'Segments',
        icon: <CallSplitIcon />,
        permissions: ROLE_SETS.devAdmin,
        link: '/segments',
    },
]

// Pinned to the bottom of the sidebar, outside the scrolling menu.
export const settingsMenuItem = {
    title: 'Settings',
    icon: <SettingsIcon />,
    permissions: ROLE_SETS.devAdmin,
    link: '/settings',
}

// The last link of the pinned bottom of the sidebar, for everyone signed in
// (also a user with no comms group, who otherwise only meets "no access").
export const guideMenuItem = {
    title: 'Guide',
    icon: <MenuBookIcon />,
    permissions: ROLE_SETS.signedIn,
    link: '/guide',
}

export const SUPPORTED_LANGUAGES = [
    { label: 'Hindi', value: 'Hindi' },
    { label: 'Tamil', value: 'Tamil' },
    { label: 'Telugu', value: 'Telugu' },
    { label: 'Kannada', value: 'Kannada' },
    { label: 'Bengali', value: 'Bengali' },
    { label: 'Marathi', value: 'Marathi' },
]
